export default "__VITE_ASSET__b6954f6a__"